import Icon from '@mui/icons-material/People';

import { CreateExpert } from './CreateExpert';
import { EditExpert } from './EditExpert';
import { ListExperts } from './ListExperts';

export const ExpertsResourceConfig = {
  list: ListExperts,
  create: CreateExpert,
  edit: EditExpert,
  icon: Icon,
  name: 'experts',
};
